import { PageSubtitleShort } from '@zoopla-eng/zds-components/headings';
import { Link } from '@zoopla-eng/zds-components/link';
import { triggerTracking } from '@zoopla/tracking';
import {
    linkWrapperStyle,
    listWrapperStyle,
    subNavigationStyle,
} from './SubNavigation.styles.css';
import { SubNavigationProps } from './SubNavigation.types';

const handleTracking = (location: string) => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'to_rent',
        eventAction: 'clickthrough',
        eventLabel: `${location}`,
    });
};

const SubNavigation = ({ subNavTitle, subNav }: SubNavigationProps) => {
    return (
        <div className={subNavigationStyle}>
            <PageSubtitleShort>{subNavTitle}</PageSubtitleShort>
            <ul className={listWrapperStyle}>
                {subNav.map((i, index) => {
                    const { linkCopy, linkSlug } = i;
                    return (
                        <li
                            className={linkWrapperStyle}
                            key={`${linkSlug}_${index}}`}
                        >
                            <Link
                                href={linkSlug}
                                onClick={() => handleTracking(linkSlug)}
                            >
                                {linkCopy}
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default SubNavigation;
